import Modal, { ModalProps } from "../Modal/Modal";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import Textarea from "../Input/Textarea";
import { useForm } from "react-hook-form";
import useReplyCustomerViaEmailPost from "@/shared/mutations/email/useReplyCustomerViaEmailPost";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import Order from "../Order/Order";

const ReplyViaEmailModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation("");
  const [{ order }] = useModalMeta();
  const setModal = useSetModal();
  const { handleSubmit, errors, register } = useForm();
  const mutation = useReplyCustomerViaEmailPost();

  const onSubmit = ({ message }) => {
    mutation.mutateAsync(
      { message, orderId: order.order_information.item_id },
      { onSuccess: () => setModal("", {}) }
    );
  };

  return (
    <Modal width={"58rem"} onExit={onExit} {...props}>
      <h3 className="mb-[1rem]">
        {t("replyViaEmailTitle")}
      </h3>
      <Order language={1} orders={order} />
      <form id="replyViaEmail" onSubmit={handleSubmit(onSubmit)} className="mt-[2rem]">
        <Textarea
          name="message"
          width="100%"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors?.message?.message}
          placeholder={t("email")}
        />
      </form>

      <Button type="submit" form="replyViaEmail" isPending={mutation.isPending}>
        {t("send")}
      </Button>
    </Modal>
  );
};

export default ReplyViaEmailModal;
